import React from 'react';
import Fontawesome from '../../fontawesome/fontawesome';
import { Link } from 'react-router-dom';
import IndexEmployers from '../../employers_clients/indexEmployers';
import Permission from '../userPermission/permission';
import Password from '../../../components/users/password/password';
import { RxEyeOpen } from 'react-icons/rx';

const OptionsUsers = (props) => {

  return (
    <div className="dropdown">
      <Link
        to="#"
        className="dropdown link_color_datatable"
        id="dropdownNotification"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <Fontawesome classe="fas fa-bars" />
      </Link>
      <ul
        className="dropdown-menu fade-in-top drop-options"
        aria-labelledby="dropdownNotification"
      >
        <li>
          <Link className="dropdown-item" to={`/gestao/permisssao-equipamentos-por-usuario/${props.id}`} >
            <RxEyeOpen style={{fontWeight: 550, fontSize: 14, marginLeft: 3, marginRight: 3}}  /> <span style={{fontWeight: 550}}>Visualização de equipamentos</span>
          </Link>
        </li>
        <li>
          <Permission
            idUser={props.id}
            buttonLabel="Permissões"
            modalSize="lg"
            iconClass="fas fa-shield-alt"
          />
        </li>
        <li>
          <Password
            id={props.id}
          />
        </li>
      </ul>
    </div>
  );
};
export default OptionsUsers;
